import { CommonPopup } from '../commonPopup/commonPopup.component';

export class ContentRatingLockPopup extends CommonPopup {
  static _template() {
    return {
      ...super._template(),
      title: 'layout.locks.contentRating.message',
    };
  }
}
